<template>
  <div>
    <b-dropdown position="is-bottom-left" append-to-body aria-role="menu" trap-focus ref="filterRef">
      <b-button
        slot="trigger"
        type="is-info"
        icon-left="filter">
          Filtrar
      </b-button>
      <b-dropdown-item
        aria-role="menu-item"
        :focusable="false"
        custom
        paddingless>
          <form action="">
            <!-- <header class="modal-card-head filter-content-padding">
            </header> -->
            <div class="modal-card" style="width:350px; overflow:visible;">
                <section class="modal-card-body filter-content-padding" style="overflow:visible;">
                  <b-field label="Lección" label-position="inside">
                    <lesson-select :selected.sync="filters.lesson"/>
                  </b-field>
                  <b-field label="Jinete" label-position="inside">
                    <rider-selector :value="filters.rider_id" @select="rider = $event" :params="{'user_status_id': 1}"/>
                  </b-field>
                  <b-field grouped>
                    <b-field label="Género" label-position="inside" expanded>
                      <b-select placeholder="Selecciona género" v-model="filters.gender" expanded>
                          <option value="all">
                            Todos
                          </option>
                          <option
                              v-for="option in generes"
                              :value="option.code"
                              :key="option.code">
                              {{ option.name }}
                          </option>
                      </b-select>
                    </b-field>
                    <b-field label="Estado" label-position="inside" expanded>
                      <b-select placeholder="Selecciona estado" v-model="filters.active" expanded>
                          <option value="all">
                            Todos
                          </option>
                          <option
                              v-for="(option, index) in status"
                              :value="option.value"
                              :key="'active-'+index">
                              {{ option.name }}
                          </option>
                      </b-select>
                    </b-field>
                    <b-field label="Nivel de Doma" label-position="inside" expanded>
                      <b-select placeholder="Selecciona nivel" v-model="filters.level_status" expanded>
                          <option value="all">
                            Todos
                          </option>
                          <option
                              v-for="option in levelStatus"
                              :value="option.code"
                              :key="option.code">
                              {{ option.name }}
                          </option>
                      </b-select>
                    </b-field>
                  </b-field>
                    <b-field label="Rango de edad" label-position="inside">
                      <b-select placeholder="Edad miníma" v-model="filters.age_from" expanded>
                          <option
                              v-for="i in 30"
                              :value="i"
                              :key="`min-${i}`" :disabled="i>filters.age_to">
                              {{ i }}
                          </option>
                      </b-select>
                      <b-select placeholder="Edad máxima" v-model="filters.age_to" expanded>
                          <option
                              v-for="i in 30"
                              :value="i"
                              :key="`max-${i}`" :disabled="i<filters.age_from">
                              {{ i }}
                          </option>
                      </b-select>
                    </b-field>
                </section>
                <footer class="modal-card-foot filter-content-padding" style="justify-content: center;">
                  <b-button type="is-danger" rounded expanded @click="restart" aria-role="menu-item">Restaurar</b-button>
                  <b-button type="is-primary" rounded expanded @click="apply" aria-role="menu-item">Aplicar</b-button>
                </footer>
            </div>
          </form>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import LessonSelect from '@/components/LessonSelect'
import RiderSelector from '@/components/RiderSelector'
import HorseFilterService from '@/services/filters/HorseFilterService'

export default {
  components: {
    LessonSelect,
    RiderSelector
  },
  created () {
    this.initFilters()
  },
  data () {
    return {
      rider: null,
      filters: {
        active: 'all',
        lesson: 0,
        gender: 'all',
        level_status: 'all',
        age_from: 1,
        age_to: 30,
        rider_id: null
      },
      generes: [
        { code: 'M', name: 'Macho' },
        { code: 'F', name: 'Hembra' }
      ],
      status: [
        { name: 'Activo', value: true },
        { name: 'Inactivo', value: false }
      ],
      levelStatus: [
        { code: 'high', name: 'Alto' },
        { code: 'medium', name: 'Medio' },
        { code: 'low', name: 'Bajo' },
        { code: 'no-level', name: 'Sin Nivel' }
      ]
    }
  },
  methods: {
    initFilters () {
      this.filters = HorseFilterService.getFilters(this.$route.query)
      this.apply()
    },
    apply () {
      let filters = this.getFilters()
      console.log(filters)
      HorseFilterService.setStorageFilters(filters)
      this.updateParams()
      this.$emit('filtered', filters)
      if (this.$refs.filterRef) {
        this.$refs.filterRef.toggle()
      }
    },
    restart () {
      this.filters = {
        active: 'all',
        lesson: 0,
        gender: 'all',
        level_status: 'all',
        age_from: 1,
        age_to: 30,
        rider_id: null
      }

      this.rider = null
      this.apply()
    },
    getFilters () {
      let filters = {
        'active': this.filters.active !== 'all' ? this.filters.active : null,
        'lesson_id': this.filters.lesson !== 0 ? this.filters.lesson : null,
        'gender': this.filters.gender !== 'all' ? this.filters.gender : null,
        'rider_id': this.filters.rider_id,
        'age_from': this.filters.age_from,
        'age_to': this.filters.age_to,
        'level_status': this.filters.level_status !== 'all' ? this.filters.level_status : null
      }
      return filters
    },
    updateParams () {
      let queryParams = this.getFilters()
      // eslint-disable-next-line handle-callback-err
      this.$router.replace({ query: queryParams }).catch(err => {})
    }
  },
  watch: {
    rider (value) {
      if (value) {
        this.filters.rider_id = value.id
      } else {
        this.filters.rider_id = null
      }
    }
  }
}
</script>

<style scoped>
  .dropdown-content{
   /* padding-top: 0px !important; */
    padding-bottom: 0px !important;
    -webkit-box-shadow: 0px 4px 9px 2px rgba(0,0,0,0.3);
    -moz-box-shadow: 0px 4px 9px 2px rgba(0,0,0,0.3);
    box-shadow: 0px 4px 9px 2px rgba(0,0,0,0.3);
  }
  .filter-content-padding{
    padding: 10px 15px;
  }

  .is-grouped{
    margin-bottom: 0px !important;
  }

  .select select option:disabled {
    color: #BDBDBD !important;
  }
</style>
